import navDeskSrc from 'assets/images/mission/nav-desktop.webp';
import navMobSrc from 'assets/images/mission/nav-mobile.webp';
import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScMissionPanel = styled.div`
  position: relative;
  display: flex;
  height: 80px;
  padding: 0 10px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: #323444;
  overflow: hidden;
  cursor: pointer;
  background-image: url(${navDeskSrc});
  background-size: cover;
  background-repeat: no-repeat;

  @media (${device.mobile}) {
    background-image: url(${navMobSrc});
  }

  & .inner {
    display: flex;
    align-items: center;
    gap: 7px;
    z-index: 1;

    @media (${device.mobile}) {
      flex-direction: row-reverse;
      gap: 10px;
    }

    & img {
      @media (${device.mobile}) {
        transform: scaleX(-1);
      }
    }
  }

  & .title {
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    line-height: 110%;

    @media (${device.mobile}) {
      max-width: none;
      font-size: 16px;
      font-weight: 700;
      line-height: 28px;
    }
  }
`;
